import {getFeatureFlags} from '@chekin/core';

const TRAVEL_GUIDE_COUNTRY_CODES = (import.meta.env.VITE_TRAVEL_GUIDE_COUNTRY_CODES ?? '')
  .split(',')
  .map((code: string) => code.trim().toUpperCase())
  .filter(Boolean);

function isTravelGuideFeatureEnabled() {
  return Boolean(getFeatureFlags('CHE_181_TRAVEL_GUIDE'));
}

function isTravelGuideCountryAllowed(countryCode?: string | null) {
  if (!TRAVEL_GUIDE_COUNTRY_CODES.length || !countryCode) {
    return false;
  }

  return TRAVEL_GUIDE_COUNTRY_CODES.includes(countryCode.trim().toUpperCase());
}

function isTravelGuideEnabled(countryCode?: string | null) {
  return isTravelGuideFeatureEnabled() && isTravelGuideCountryAllowed(countryCode);
}

function formatSourceLabel(url: string): string {
  try {
    return new URL(url).hostname.replace(/^www\./, '');
  } catch {
    return url;
  }
}

export {isTravelGuideEnabled, formatSourceLabel};
